// extracted by extract-css-chunks-webpack-plugin
module.exports = {"btn":"_9Ws5AiF6E-SytIX2wzS8eg=="};